/// <amd-module name="DistributedTask/Common/AzureResourcesService/AzureResourceContracts" />
import { AzureMLWorkspace, AzureAppService } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";

export interface IKubernetesCluster {
    id: string;
    name: string;
    fqdn: string;
    resourceGroup?: string;
}

export interface IAzureRequestResult {
    data: string[] | IKubernetesCluster[] | AzureMLWorkspace[] | AzureAppService[];
    callbackRequired: boolean;
    callbackParameters: { [key: string]: string };
}